import React,{useEffect, useState, useRef, useMemo} from 'react';
import './warning.css';
import { playMusic, pauseMusic, setVolume, transitionVolume } from '../musicEngine/musicEngine';

function Warning({goNext, language, setLang, disclaimerShown, setDisclaimerShown, navigation, hzAdjuster, startDetection, setHzAdjuster}) {
  const [white, setWhite] = useState(0);
  const [clicked, setClicked] = useState(true);
  const noMinors = useRef(null);
  const disclaimer = useRef(null);
  const languageSelect = useRef(null);
  const txtRef = useRef(null);
  const tapRef = useRef(null);
  const save = useRef(null);
  let num = useRef(0);
  let detectionFinished = useRef(false);
  let appearedNoMinor = useRef(false);
  const wrap = useRef(null);

  let text = {
    en:{
      chooseLang:"Choose language:",
      tapTo:"Tap to continue",
      pg:"18+",
      noMinors:"No minors allowed",
      titleDisc:"Disclaimer",
      disclaimer1:"All characters appearing in this work are fictitious and are 18 years old or above. Any resemblance to real persons, living or dead, is purely coincidental.",
      disclaimer2:"The game does not claim the depth of presented knowledge and is mainly designed for entertainment, please take what is happening with some irony.",
      disclaimer3:"Sex educator SHOULD NOT participate in the sex process and can only help with theory and mental or emotional aspects of sex-related problems (if certified as a therapist).",
      titleSave:"💾",
      saveText:"Your progress saves automatically",
      saveText2:"You can start any chapter from the beginning in the “Chapters” tab",
    },
    ru:{
      chooseLang:"Выберите язык:",
      tapTo:"Нажмите, чтобы продолжить",
      pg:"18+",
      noMinors:"Контент только для взрослых",
      titleDisc:"Дисклеймер",
      disclaimer1:"Все персонажи данного произведения являются вымышленными и достигли 18-летнего возраста. Любое сходство с реальными лицами, живыми или умершими, является совпадением.",
      disclaimer2:"Эта игра не претендует на глубину представленных знаний и предназначена в первую очередь для развлечения, прошу относиться к происходящему в ней с долей иронии.",
      disclaimer3:"Сексолог НЕ ДОЛЖЕН принимать участие в половом акте и может помогать только в вопросах теории, а также в решении психологических или эмоциональных аспектов проблем, связанных с сексом (если является дипломированным психологом).",
      titleSave:"💾",
      saveText:"Ваш прогресс сохраняется автоматически",
      saveText2:"Вы можете начать любую главу с начала из вкладки “главы”",
    }
  }

  useEffect(() => {
    start();
    async function start(){
      await changeSetting(wrap,"current.style.opacity", 0, "", 0.018);
      await changeSetting(noMinors,"current.style.opacity", 1, "", 0.018);
      appearedNoMinor.current=true;
    }
    if(language == "en"){
      document.getElementById("option-one").defaultChecked = "true";
    }else if(language == "ru"){
      document.getElementById("option-two").defaultChecked = "true";
    }
    if(navigation !== null && navigation !== 0 && !disclaimerShown){
      languageSelect.current.style.zIndex = "1";
      txtRef.current.style.zIndex = "1";
      languageSelect.current.style.display = "none";
      noMinors.current.style.display = "block";
      tapRef.current.style.display = "block";
    }
  },[]);

function langSelect(e){
  setLang(e.currentTarget.value);
}

function waitingFunc(t){
  return new Promise(async (resolve, reject) => {
      setTimeout(f,t);
    function f(){
      resolve();
      return;
    }
  });
}

  async function go(){

    await goo();
       function goo(){
            return new Promise( async (resolve, reject) => {
              setClicked(false);
              if(num.current == 0){
                detectRefreshRate().then((rate) => {
                  rate=100/roundFive(rate);
                  setHzAdjuster(rate);
                  detectionFinished.current = true;
                });
                if(navigation !== null && navigation !== 0 && !disclaimerShown){
                  console.log(appearedNoMinor.current);
                  if(!appearedNoMinor.current){
                    setClicked(true);
                    resolve();
                    return;
                  }else{
                    await waitingFunc(200);
                  }
                  await changeSetting(noMinors,"current.style.opacity", 0, "", 0.015);
                  await changeSetting(wrap,"current.style.opacity", 1, "", 0.012);
                  while(!detectionFinished.current){
                    await waitingFunc(16);
                  }
                  setDisclaimerShown(true);
                  return;
                }
                languageSelect.current.style.zIndex = "1";
                txtRef.current.style.zIndex = "1";
                await changeSetting(languageSelect,"current.style.opacity", 0, "", 0.015);
                languageSelect.current.style.display = "none";
                noMinors.current.style.opacity = "0";
                noMinors.current.style.display = "block";
                await changeSetting(noMinors,"current.style.opacity", 1, "", 0.013);
                setClicked(true);
                num.current++;
                resolve();
              }else if(num.current == 1){
                await changeSetting(noMinors,"current.style.opacity", 0, "", 0.015);
                tapRef.current.style.display = "none";
                noMinors.current.style.display = "none";
                disclaimer.current.style.display = "block";
                await changeSetting(disclaimer,"current.style.opacity", 1, "", 0.013);
                setClicked(true);
                num.current++;
                resolve();
              }else if(num.current == 2){
                await changeSetting(disclaimer,"current.style.opacity", 0, "", 0.015);
                tapRef.current.style.display = "none";
                disclaimer.current.style.display = "none";
                save.current.style.display = "block";
                await changeSetting(save,"current.style.opacity", 1, "", 0.013);
                setClicked(true);
                num.current++;
                resolve();
              }else if(num.current > 2){
                await changeSetting(save,"current.style.opacity", 0, "", 0.015);
                await changeSetting(wrap,"current.style.opacity", 1, "", 0.012);
                setDisclaimerShown(true);
                goNext();
                resolve();
              }
              });
            }
  }


  function detectRefreshRate() {
      return new Promise((resolve) => {
          const frameTimes = [];
          const framesToMeasure = 70;

          function measureFrame(startTime) {
              requestAnimationFrame((endTime) => {
                  frameTimes.push(endTime - startTime);

                  if (frameTimes.length < framesToMeasure) {
                      measureFrame(endTime);
                  } else {
                      const avgFrameTime = frameTimes.reduce((a, b) => a + b, 0) / frameTimes.length;
                      const refreshRate = Math.round(1000 / avgFrameTime);
                      resolve(refreshRate);
                  }
              });
          }

          measureFrame(performance.now());
      });
  }

  function roundFive(num){
    let n = num % 10;
    if(n>=5){
      if(n>7.5){
        return num - n + 10;
      }else if(n<=7.5){
        return num - n+5;
      }
    }else if(n<5){
      if(n>2.5){
        return num - n + 5;
      }else if(n<=2.5){
        return num - n;
      }
    }
  }

  function changeSetting(obj, setting, changeTo, um, speed, char){
    speed = speed*2*hzAdjuster;
    return new Promise((resolve, reject) => {
      const props = setting
          .split(/[./[\]]/g)
          .filter(p => p);
      const prop = props.pop();
      const parent = props.reduce((result, key) => result[key], obj);
      //
      var i;
      if(setting == "current.style.transform" || setting == "style.transform"){
        i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
      }else{
        i = Math.round(parseFloat(parent[prop]));
      }
      let slowDownTrigger = 0;
    //  if(char){//delete
    //slowDownTrigger = Math.round(parseFloat(Math.abs((char.initialPointX[0]-char.destinationPointX)/char.speed)*0.8));//moment of slower of char
    //}
    //  let slowDownCounter=0;
      let slower = 8;
      change();
    function change(){
      //slowDownCounter++;
    //  if(slowDownCounter > slowDownTrigger && char != undefined){ //delete
    //    slower+=3; //slower of char
    //  }
    //  console.log(slower);

      if(i>changeTo){
        i-=speed;
        if(i<changeTo){
          i = changeTo;
          if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
            parent[prop] = "scale("+i+")";
          }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
            parent[prop] = "rotateY("+i+"deg)";
          }else{
            parent[prop] = i+um;
          }
          resolve();
          return;
        }
    }else if(i<changeTo){
      i+=speed;
      if(i>changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        resolve();
        return;
      }
    }else{
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      resolve();
      return;
    }
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
  requestAnimationFrame(change);
  return;
  }
  });
  }

return(
<div className='blcwrap'>
<div className='clickWrap' onClick={clicked? go : undefined} id='wrap' ref={wrap} style={{opacity:"1"}}></div>
<div className='txt1' ref={txtRef} style={{zIndex:"20"}}>
<div style={{display:"block", zIndex:"20", opacity:"1"}} className="languageSelect" ref={languageSelect}>
<h1 style={{fontSize:"30px"}} onClick={clicked? go : undefined}>{text[language]["chooseLang"]}</h1>
<form>
 <div className="radio-group">
<input type="radio" id="option-one" name="selector" value="en" onClick={langSelect} /><label htmlFor="option-one">English</label>
<input type="radio" id="option-two" name="selector" value="ru" onClick={langSelect} /><label htmlFor="option-two">Русский</label>
  </div>
   </form>
<br/>
<h2 onClick={clicked? go : undefined}>{text[language]["tapTo"]}</h2>
</div>
<div style={{display:"none", opacity:"0"}} ref={noMinors}>
<h1 style={{fontSize:"30px", color:"#ff2626"}}>{text[language]["pg"]}</h1>
<h1 style={{fontSize:"25px", color:"#ff2626"}}>{text[language]["noMinors"]}</h1>
<h2 style={{marginTop:"1vh"}}>{text[language]["disclaimer1"]}</h2>
<br/>
<h2 ref={tapRef} style={{display:"none"}}>{text[language]["tapTo"]}</h2>
</div>
<div style={{display:"none", opacity:"0"}} ref={disclaimer}>
<h1 style={{fontSize:"30px", color:"#ff2626"}}>{text[language]["titleDisc"]}</h1>
<h2 style={{marginTop:"2vh"}}>{text[language]["disclaimer2"]}</h2>
<h2 style={{marginTop:"3vh", fontSize:"18px", color:"#ff2626"}}>{text[language]["disclaimer3"]}</h2>
<br/>
</div>
<div style={{display:"none", opacity:"0"}} ref={save}>
<h1 style={{fontSize:"30px", color:"#ff2626"}}>{text[language]["titleSave"]}</h1>
<h2 style={{marginTop:"2vh"}}>{text[language]["saveText"]}</h2>
<h2 style={{marginTop:"3vh", fontSize:"18px", color:"#b0b0b0"}}>{text[language]["saveText2"]}</h2>
<br/>
</div>
</div>
</div>
);

}

export default Warning;
